import React from 'react';
import { Box } from '@material-ui/core';
import { SampleSort } from './IllustrativeContent';

const Sort = ({ illustrative = false, ...props }) => illustrative ? <SampleSort /> : (
  <Box display="flex" alignItems="center" gap={1} {...props}>
    {/* Select Box */}
    <Box
      width={140}
      height={32}
      bgcolor="#ffffff"
      border="1px solid #e0e0e0"
      borderRadius={4}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      px={1.5}
    >
      <Box width={60} height={8} bgcolor="#e0e0e0" borderRadius={4} />
      <Box width={10} height={6} bgcolor="#bdbdbd" style={{ clipPath: 'polygon(0 0, 50% 100%, 100% 0)' }} />
    </Box>
  </Box>
);

export default Sort;
